import { createAuthSession } from "@ametie/vue-muza-use";

import { useAuthStore } from "@/features/auth";

// The declarative refresh does not inherit a client's base URL, so the session
// and `myAxios` must read the same constant.
export const INSIGHTS_API_BASE_URL = import.meta.env.VITE_API_URL
  ? `${import.meta.env.VITE_API_URL}`
  : "/api";

export const authSession = createAuthSession({
  refresh: {
    url: "/auth/refresh",
    baseURL: INSIGHTS_API_BASE_URL,
    withCredentials: true,
  },
  // The refresh token lives in the httpOnly cookie. The legacy
  // `refreshWithCredentials` implied access-token-only storage; the session
  // does not, so without this a refresh token from the response body would
  // land in localStorage.
  storeRefreshToken: false,
});

authSession.on("refreshFailed", () => {
  // Resolved lazily: Pinia is not available while this module is evaluated.
  // logout() clears tokens and user-scoped state and routes to /login.
  void useAuthStore().logout();
});
